// extracted by mini-css-extract-plugin
export default {"carousel":"ProjectCarousel_carousel__sayfP"};